export enum ApprovalIssueTypeEnum {
  ISSUE_CHECKIN_TIME = 0,
  ISSUE_CHECKOUT_TIME = 1,
  ISSUE_OVERTIME = 2,
  ISSUE_NOTES = 3,
  ISSUE_CREATE_SCHEDULE = 4,
  ISSUE_CHANGE_SCHEDULE = 5,
  ISSUE_PERMIT = 6,
  ISSUE_BULK_UPLOAD_SCHEDULE = 7,
  ISSUE_ADD_OVERTIME_SCHEDULE = 8,
  ISSUE_ONLEAVE = 9,
  ISSUE_DAYOFF_OVERTIME = 10,
  ISSUE_TERMINATION = 11,
  ISSUE_PROPOSE_TERMINATION = 12,
  ISSUE_REJOIN = 13,
  ISSUE_JOB_REQUEST = 14,
  ISSUE_CHECKOUT_TIME_5H_EXT = 15,
  ISSUE_CHECKOUT_TIME_5H_EXT_AM = 16,
  ISSUE_OVERTIME_POST_CO = 17,
  ISSUE_OVERTIME_POST_CO_AM = 18,
}

export const HR_ELIGIBLE_ISSUE_TYPES: ApprovalIssueTypeEnum[] = [
  ApprovalIssueTypeEnum.ISSUE_TERMINATION,
  ApprovalIssueTypeEnum.ISSUE_REJOIN,
]

export const MANAGER_ELIGIBLE_ISSUE_TYPES: ApprovalIssueTypeEnum[] = [
  ApprovalIssueTypeEnum.ISSUE_CHECKOUT_TIME_5H_EXT,
  ApprovalIssueTypeEnum.ISSUE_CHECKOUT_TIME_5H_EXT_AM,
  ApprovalIssueTypeEnum.ISSUE_OVERTIME_POST_CO,
  ApprovalIssueTypeEnum.ISSUE_OVERTIME_POST_CO_AM,
]

export const SPV_ELIGIBLE_ISSUE_TYPES: ApprovalIssueTypeEnum[] = [
  ApprovalIssueTypeEnum.ISSUE_CHECKOUT_TIME_5H_EXT,
  ApprovalIssueTypeEnum.ISSUE_OVERTIME_POST_CO,
]

export const BULK_APPROVAL_DISABLED_ISSUE_TYPES: ApprovalIssueTypeEnum[] = [
  ApprovalIssueTypeEnum.ISSUE_BULK_UPLOAD_SCHEDULE,
  ApprovalIssueTypeEnum.ISSUE_TERMINATION,
  ApprovalIssueTypeEnum.ISSUE_PROPOSE_TERMINATION,
  ApprovalIssueTypeEnum.ISSUE_REJOIN,
]

export const APPROVAL_ISSUE_LABELS: Record<ApprovalIssueTypeEnum, string> = {
  [ApprovalIssueTypeEnum.ISSUE_CHECKIN_TIME]: 'Jam Masuk',
  [ApprovalIssueTypeEnum.ISSUE_CHECKOUT_TIME]: 'Jam Pulang',
  [ApprovalIssueTypeEnum.ISSUE_OVERTIME]: 'Lembur',
  [ApprovalIssueTypeEnum.ISSUE_NOTES]: 'Catatan',
  [ApprovalIssueTypeEnum.ISSUE_CREATE_SCHEDULE]: 'Pembuatan Jadwal Kerja',
  [ApprovalIssueTypeEnum.ISSUE_CHANGE_SCHEDULE]: 'Perubahan Jadwal Kerja',
  [ApprovalIssueTypeEnum.ISSUE_PERMIT]: 'Izin Hari H',
  [ApprovalIssueTypeEnum.ISSUE_BULK_UPLOAD_SCHEDULE]: 'Bulk Upload Jadwal Kerja',
  [ApprovalIssueTypeEnum.ISSUE_ADD_OVERTIME_SCHEDULE]: 'Tambah Lembur Jadwal Kerja',
  [ApprovalIssueTypeEnum.ISSUE_ONLEAVE]: 'Izin',
  [ApprovalIssueTypeEnum.ISSUE_DAYOFF_OVERTIME]: 'Lembur Hari Off',
  [ApprovalIssueTypeEnum.ISSUE_TERMINATION]: 'Pemutusan Hubungan Kerja',
  [ApprovalIssueTypeEnum.ISSUE_PROPOSE_TERMINATION]: 'Pengajuan Pemutusan Hubungan Kerja',
  [ApprovalIssueTypeEnum.ISSUE_REJOIN]: 'Pengajuan Rejoin',
  [ApprovalIssueTypeEnum.ISSUE_JOB_REQUEST]: 'Job Request',
  [ApprovalIssueTypeEnum.ISSUE_CHECKOUT_TIME_5H_EXT]: 'Jam Pulang 5 Jam Ext',
  [ApprovalIssueTypeEnum.ISSUE_CHECKOUT_TIME_5H_EXT_AM]: 'Jam Pulang 5 Jam Ext AM',
  [ApprovalIssueTypeEnum.ISSUE_OVERTIME_POST_CO]: 'Lembur Post Checkout',
  [ApprovalIssueTypeEnum.ISSUE_OVERTIME_POST_CO_AM]: 'Lembur Post Checkout AM',
}
